import { useEffect, useState } from 'react';

import { tracking } from '@iwoca/frontend-tracking-library';

import { FundingProgressIndicator } from '../../../../funding/fundingSteps/FundingProgessIndicator/FundingProgressIndicator';
import { FlexiApprovedView } from '../../../approvedView/flexiApprovedView/FlexiApprovedView';
import { RecommendedOfferView } from '../../../approvedView/recommendedOfferView/RecommendedOfferView';

export const RecommendedOfferPage = () => {
    const [showAllOptions, setShowAllOptions] = useState(false);

    useEffect(() => {
        tracking.ampli.approvedViewVisited({
            status: 'recommended',
            offers_page_version: '1.0'
        });
    }, []);

    if (showAllOptions) {
        return (
            <>
                <FundingProgressIndicator step={1} />
                <FlexiApprovedView setShowAllOptions={setShowAllOptions} />
            </>
        );
    }

    return (
        <>
            <FundingProgressIndicator step={1} />
            <RecommendedOfferView setShowAllOptions={setShowAllOptions} />
        </>
    );
};
